import { useEffect, useState, type PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';

import type { ClavePoliticaUsuario, RolUsuario } from 'tipos/autenticacion';
import {
  obtenerInformacionUsuarioDesdeToken,
  obtenerRutaRedireccionPorPoliticas,
  validarToken,
} from 'utilidades/autenticacion';
import { limpiarCookiesAplicacion } from 'utilidades/cookies';

interface PropsRutaProtegida extends PropsWithChildren {
  requiredRole?: RolUsuario;
  requiredPolicy?: ClavePoliticaUsuario;
}

const RutaProtegida = ({ children, requiredRole, requiredPolicy }: PropsRutaProtegida) => {
  const [estaAutenticado, setEstaAutenticado] = useState(false);
  const [estaCargando, setEstaCargando] = useState(true);
  const [tieneRole, setTieneRole] = useState(false);
  const [tienePolitica, setTienePolitica] = useState(false);
  const [rutaRedireccion, setRutaRedireccion] = useState('/login');

  useEffect(() => {
    const verificarAcceso = () => {
      const tokenValido = validarToken();

      if (!tokenValido) {
        limpiarCookiesAplicacion();
        setRutaRedireccion('/login');
        setEstaCargando(false);
        return;
      }

      const informacionUsuario = obtenerInformacionUsuarioDesdeToken();

      setEstaAutenticado(true);
      setTieneRole(requiredRole ? informacionUsuario?.role === requiredRole : true);
      setTienePolitica(
        requiredPolicy
          ? informacionUsuario?.[requiredPolicy] === 1 || informacionUsuario?.[requiredPolicy] === null
          : true
      );
      setRutaRedireccion(obtenerRutaRedireccionPorPoliticas(informacionUsuario));
      setEstaCargando(false);
    };

    verificarAcceso();
  }, [requiredPolicy, requiredRole]);

  if (estaCargando) {
    return <div>Cargando...</div>;
  }

  if (!estaAutenticado || !tieneRole || !tienePolitica) {
    return <Navigate to={rutaRedireccion} />;
  }

  return <>{children}</>;
};

export default RutaProtegida;
